import {axiosFormDataInstance, axiosInstance} from "./axiosConfig";


export const listSims = async (page=1,perPage,search='',$type='',status='') => {
    let url = '/sim?page='+page+'&per_page='+perPage;
    if(search !== ''){
        url = url+'&search='+search;
    }
    if($type !== '' && $type !== 'all'){
        url = url+'&type='+$type;
    }
    if(status !== '' && status !== 'All'){
        url = url+'&status='+status;
    }
    return axiosInstance.get(url);
};

export const createSim = async (serial_number,sim_number,puk,customer_id) => {
    return axiosInstance.post('/sim', {serial_number,sim_number,puk,customer_id});
};

export const showSim = async (id) => {
    return axiosInstance.get('/sim/'+id);
};

export const deleteSim = async (id) => {
    return axiosInstance.delete('/sim/'+id);
};

export const updateSim = async (id,status,reject_reason) => {
    return axiosInstance.put('/sim/'+id, {status,reject_reason});
};